import { DatalossSource, DatalossType } from '@fullstory/proto/fs/cook';
import {
  Category,
  DetectionEventRecord,
  GetAllInTimeRangeResponse,
  TriageState,
} from '@fullstory/proto/fs/services/dataloss';
import { Timestamp } from '@fullstory/proto/google/protobuf';

const now = new Date(Date.now());

export const mockDetectionEventRecord0: DetectionEventRecord = {
  id: 'mockDetectionEventRecordId0',
  eventInfo: {
    detectionType: DatalossType.DATALOSS_TYPE_PAYMENT_CARD,
    detail: {
      source: DatalossSource.DATALOSS_SOURCE_INPUT_ELEMENT,
      origin: 'value',
      selector: 'body div div .test',
      namedElementId: '',
    },
  },
  triageState: TriageState.NEW,
  lastSeen: Timestamp.fromDate(now),
  category: Category.CATEGORY_UNSET,
  lastMarkedFixed: null,
  count: 0,
};

export const mockDetectionEventRecord1: DetectionEventRecord = {
  id: 'mockDetectionEventRecordId1',
  eventInfo: {
    detectionType: DatalossType.DATALOSS_TYPE_PASSWORD,
    detail: {
      source: DatalossSource.DATALOSS_SOURCE_ELEMENT,
      origin: '',
      selector: 'body div div .test .foo .bar .baz',
      namedElementId: '',
    },
  },
  triageState: TriageState.NEW,
  lastSeen: Timestamp.fromDate(now),
  category: Category.CATEGORY_UNSET,
  lastMarkedFixed: null,
  count: 0,
};

export const GET_ALL_IN_TIME_RANGE_RESPONSE: GetAllInTimeRangeResponse = {
  detectionEventRecords: [mockDetectionEventRecord0, mockDetectionEventRecord1],
};
